export const aiCallInfo = {
    namespaced: true,
    state: () => ({
        
    }),
    getters: {

    },
    mutations: {

    },
    actions: {
        
    },
}